import { H as HoverableView } from '../../dist/index-a9a6637c.esm.js';
import PropTypes from 'prop-types';
import React__default, { useState } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { u as useTheme } from '../../dist/useTheme-90e8e2c2.esm.js';
import { g as genericStyles } from '../../dist/genericStyles-b9567994.esm.js';
import { A as AppText, a as AppIcon } from '../../dist/index-6b88191c.esm.js';
import { A as AppPopup } from '../../dist/index-f89540e5.esm.js';
import { Popable } from 'react-native-popable';
import '../../dist/extends-a2cb9f0c.esm.js';
import 'react-i18next';
import '../../dist/index-0ee62650.esm.js';
import '@fortawesome/react-native-fontawesome';
import 'markdown-it';
import 'mermaid';
import '../../dist/index-3256db5b.esm.js';
import '@fortawesome/pro-light-svg-icons/faAdjust';
import '@fortawesome/pro-light-svg-icons/faAlignCenter';
import '@fortawesome/pro-light-svg-icons/faAlignLeft';
import '@fortawesome/pro-light-svg-icons/faAlignRight';
import '@fortawesome/pro-light-svg-icons/faArrowCircleRight';
import '@fortawesome/pro-light-svg-icons/faArrowSquareLeft';
import '@fortawesome/pro-light-svg-icons/faArrowToRight';
import '@fortawesome/pro-light-svg-icons/faBan';
import '@fortawesome/pro-light-svg-icons/faBars';
import '@fortawesome/pro-light-svg-icons/faBell';
import '@fortawesome/pro-light-svg-icons/faBezierCurve';
import '@fortawesome/pro-light-svg-icons/faBold';
import '@fortawesome/pro-light-svg-icons/faBookOpen';
import '@fortawesome/pro-light-svg-icons/faBookReader';
import '@fortawesome/pro-light-svg-icons/faBookmark';
import '@fortawesome/pro-light-svg-icons/faBooks';
import '@fortawesome/pro-light-svg-icons/faBracketsCurly';
import '@fortawesome/pro-light-svg-icons/faBrain';
import '@fortawesome/pro-light-svg-icons/faHeadSideBrain';
import '@fortawesome/pro-light-svg-icons/faBrowser';
import '@fortawesome/pro-light-svg-icons/faCalendarDay';
import '@fortawesome/pro-light-svg-icons/faCalendarEdit';
import '@fortawesome/pro-light-svg-icons/faFileChartLine';
import '@fortawesome/pro-light-svg-icons/faChartColumn';
import '@fortawesome/pro-light-svg-icons/faChartNetwork';
import '@fortawesome/pro-light-svg-icons/faCheckCircle';
import '@fortawesome/pro-light-svg-icons/faChevronDoubleUp';
import '@fortawesome/pro-light-svg-icons/faChevronDown';
import '@fortawesome/pro-light-svg-icons/faChevronLeft';
import '@fortawesome/pro-light-svg-icons/faScannerTouchscreen';
import '@fortawesome/pro-light-svg-icons/faChevronRight';
import '@fortawesome/pro-light-svg-icons/faChevronUp';
import '@fortawesome/pro-light-svg-icons/faCircle';
import '@fortawesome/pro-light-svg-icons/faClipboard';
import '@fortawesome/pro-light-svg-icons/faClipboardListCheck';
import '@fortawesome/pro-light-svg-icons/faSparkles';
import '@fortawesome/pro-light-svg-icons/faClock';
import '@fortawesome/pro-light-svg-icons/faClone';
import '@fortawesome/pro-light-svg-icons/faCloudDownload';
import '@fortawesome/pro-light-svg-icons/faCloudUpload';
import '@fortawesome/pro-light-svg-icons/faCode';
import '@fortawesome/pro-light-svg-icons/faCodeMerge';
import '@fortawesome/pro-light-svg-icons/faCog';
import '@fortawesome/pro-light-svg-icons/faCommentAltLines';
import '@fortawesome/pro-light-svg-icons/faCommentLines';
import '@fortawesome/pro-light-svg-icons/faCommentsAlt';
import '@fortawesome/pro-light-svg-icons/faCompressAlt';
import '@fortawesome/pro-light-svg-icons/faCopy';
import '@fortawesome/pro-light-svg-icons/faCreditCard';
import '@fortawesome/pro-light-svg-icons/faDatabase';
import '@fortawesome/pro-light-svg-icons/faDollarSign';
import '@fortawesome/pro-light-svg-icons/faEdit';
import '@fortawesome/pro-light-svg-icons/faEllipsisH';
import '@fortawesome/pro-light-svg-icons/faEllipsisV';
import '@fortawesome/pro-light-svg-icons/faEnvelopeOpenText';
import '@fortawesome/pro-light-svg-icons/faEraser';
import '@fortawesome/pro-light-svg-icons/faExchangeAlt';
import '@fortawesome/pro-light-svg-icons/faExclamationTriangle';
import '@fortawesome/pro-light-svg-icons/faExpandAlt';
import '@fortawesome/pro-light-svg-icons/faExpandWide';
import '@fortawesome/pro-light-svg-icons/faEye';
import '@fortawesome/pro-light-svg-icons/faEyeSlash';
import '@fortawesome/pro-light-svg-icons/faFile';
import '@fortawesome/pro-light-svg-icons/faFileAlt';
import '@fortawesome/pro-light-svg-icons/faFileCode';
import '@fortawesome/pro-light-svg-icons/faFileCsv';
import '@fortawesome/pro-light-svg-icons/faFileExcel';
import '@fortawesome/pro-light-svg-icons/faFileExport';
import '@fortawesome/pro-light-svg-icons/faFileImport';
import '@fortawesome/pro-light-svg-icons/faFileInvoiceDollar';
import '@fortawesome/pro-light-svg-icons/faFilePdf';
import '@fortawesome/pro-light-svg-icons/faFilePowerpoint';
import '@fortawesome/pro-light-svg-icons/faFileSignature';
import '@fortawesome/pro-light-svg-icons/faFileUpload';
import '@fortawesome/pro-light-svg-icons/faFileWord';
import '@fortawesome/pro-light-svg-icons/faFolder';
import '@fortawesome/pro-light-svg-icons/faFont';
import '@fortawesome/pro-light-svg-icons/faGameBoardAlt';
import '@fortawesome/pro-light-svg-icons/faGlobeEurope';
import '@fortawesome/pro-light-svg-icons/faGlobePointer';
import '@fortawesome/pro-light-svg-icons/faGripLinesVertical';
import '@fortawesome/pro-light-svg-icons/faGripVertical';
import '@fortawesome/pro-light-svg-icons/faH1';
import '@fortawesome/pro-light-svg-icons/faH2';
import '@fortawesome/pro-light-svg-icons/faHashtag';
import '@fortawesome/pro-light-svg-icons/faHighlighter';
import '@fortawesome/pro-light-svg-icons/faHistory';
import '@fortawesome/pro-light-svg-icons/faHomeAlt';
import '@fortawesome/pro-light-svg-icons/faImage';
import '@fortawesome/pro-light-svg-icons/faInbox';
import '@fortawesome/pro-light-svg-icons/faIndent';
import '@fortawesome/pro-light-svg-icons/faInfoCircle';
import '@fortawesome/pro-light-svg-icons/faItalic';
import '@fortawesome/pro-light-svg-icons/faKeyboard';
import '@fortawesome/pro-light-svg-icons/faLanguage';
import '@fortawesome/pro-light-svg-icons/faLaptopCode';
import '@fortawesome/pro-light-svg-icons/faLayerGroup';
import '@fortawesome/pro-light-svg-icons/faLightbulbExclamation';
import '@fortawesome/pro-light-svg-icons/faLink';
import '@fortawesome/pro-light-svg-icons/faListOl';
import '@fortawesome/pro-light-svg-icons/faListUl';
import '@fortawesome/pro-light-svg-icons/faLock';
import '@fortawesome/pro-light-svg-icons/faLockOpen';
import '@fortawesome/pro-light-svg-icons/faMeteor';
import '@fortawesome/pro-light-svg-icons/faMicrophone';
import '@fortawesome/pro-light-svg-icons/faMoneyCheckAlt';
import '@fortawesome/pro-light-svg-icons/faNetworkWired';
import '@fortawesome/pro-light-svg-icons/faPaintRoller';
import '@fortawesome/pro-light-svg-icons/faPaperPlaneTop';
import '@fortawesome/pro-light-svg-icons/faPen';
import '@fortawesome/pro-light-svg-icons/faPlanetRinged';
import '@fortawesome/pro-light-svg-icons/faPlus';
import '@fortawesome/pro-light-svg-icons/faPlusCircle';
import '@fortawesome/pro-light-svg-icons/faPowerOff';
import '@fortawesome/pro-light-svg-icons/faQuestion';
import '@fortawesome/pro-light-svg-icons/faQuestionCircle';
import '@fortawesome/pro-light-svg-icons/faQuoteLeft';
import '@fortawesome/pro-light-svg-icons/faRedo';
import '@fortawesome/pro-light-svg-icons/faReply';
import '@fortawesome/pro-light-svg-icons/faRocketLaunch';
import '@fortawesome/pro-light-svg-icons/faSatelliteDish';
import '@fortawesome/pro-light-svg-icons/faScrubber';
import '@fortawesome/pro-light-svg-icons/faSearch';
import '@fortawesome/pro-light-svg-icons/faSearchMinus';
import '@fortawesome/pro-light-svg-icons/faSearchPlus';
import '@fortawesome/pro-light-svg-icons/faShareAlt';
import '@fortawesome/pro-light-svg-icons/faSignOut';
import '@fortawesome/pro-light-svg-icons/faSlidersV';
import '@fortawesome/pro-light-svg-icons/faSlidersVSquare';
import '@fortawesome/pro-light-svg-icons/faSpinner';
import '@fortawesome/pro-light-svg-icons/faStopCircle';
import '@fortawesome/pro-light-svg-icons/faStream';
import '@fortawesome/pro-light-svg-icons/faStrikethrough';
import '@fortawesome/pro-light-svg-icons/faSync';
import '@fortawesome/pro-light-svg-icons/faTag';
import '@fortawesome/pro-light-svg-icons/faTerminal';
import '@fortawesome/pro-light-svg-icons/faThumbsDown';
import '@fortawesome/pro-light-svg-icons/faThumbsUp';
import '@fortawesome/pro-light-svg-icons/faThumbtack';
import '@fortawesome/pro-light-svg-icons/faTimes';
import '@fortawesome/pro-light-svg-icons/faTimesCircle';
import '@fortawesome/pro-light-svg-icons/faTrash';
import '@fortawesome/pro-light-svg-icons/faTypewriter';
import '@fortawesome/pro-light-svg-icons/faUnderline';
import '@fortawesome/pro-light-svg-icons/faUndo';
import '@fortawesome/pro-light-svg-icons/faUnlink';
import '@fortawesome/pro-light-svg-icons/faUser';
import '@fortawesome/pro-light-svg-icons/faUserCircle';
import '@fortawesome/pro-light-svg-icons/faUserLock';
import '@fortawesome/pro-light-svg-icons/faUserBeardBolt';
import '@fortawesome/pro-light-svg-icons/faUserRobot';
import '@fortawesome/pro-light-svg-icons/faUserSecret';
import '@fortawesome/pro-light-svg-icons/faUserAstronaut';
import '@fortawesome/pro-light-svg-icons/faUserShield';
import '@fortawesome/pro-light-svg-icons/faUsers';
import '@fortawesome/pro-light-svg-icons/faUsersCog';
import '@fortawesome/pro-light-svg-icons/faVial';
import '@fortawesome/pro-light-svg-icons/faWaveSquare';
import '@fortawesome/pro-light-svg-icons/faWifiSlash';
import '@fortawesome/pro-light-svg-icons/faWindowMinimize';
import '@fortawesome/pro-light-svg-icons/faChartBar';
import '@fortawesome/pro-light-svg-icons/faSlidersH';
import '@fortawesome/pro-light-svg-icons/faPageBreak';
import '@fortawesome/pro-light-svg-icons/faServer';
import '@fortawesome/pro-light-svg-icons/faTools';
import '@fortawesome/pro-light-svg-icons/faAnalytics';
import '@fortawesome/pro-light-svg-icons/faTrophy';
import '@fortawesome/pro-light-svg-icons/faDice';
import '@fortawesome/pro-light-svg-icons/faSwords';
import '@fortawesome/pro-light-svg-icons/faBoxingGlove';
import '@fortawesome/pro-light-svg-icons/faRandom';
import '@fortawesome/pro-light-svg-icons/faVideoPlus';
import '@fortawesome/pro-light-svg-icons/faFileAudio';
import '@fortawesome/pro-light-svg-icons/faMagic';
import '@fortawesome/pro-light-svg-icons/faSitemap';
import '@fortawesome/pro-light-svg-icons/faFiles';
import '@fortawesome/pro-light-svg-icons/faUserShakespeare';
import '@fortawesome/pro-light-svg-icons/faUserPilot';
import '@fortawesome/pro-light-svg-icons/faUserPilotTie';
import '@fortawesome/pro-light-svg-icons/faUserRobotXmarks';
import '@fortawesome/pro-light-svg-icons/faUserVisor';
import '@fortawesome/pro-light-svg-icons/faUserNinja';
import '@fortawesome/pro-light-svg-icons/faUserGear';
import '@fortawesome/pro-light-svg-icons/faArrowTurnDownRight';
import '@fortawesome/pro-light-svg-icons/faTriangleExclamation';
import '@fortawesome/pro-light-svg-icons/faMessageBot';
import '@fortawesome/pro-light-svg-icons/faVolume';
import '@fortawesome/pro-light-svg-icons/faVolumeSlash';
import '@fortawesome/pro-light-svg-icons/faImages';
import '@fortawesome/pro-light-svg-icons/faSwordLaser';
import '@fortawesome/pro-light-svg-icons/faSwordsLaser';
import '@fortawesome/pro-light-svg-icons/faHelmetBattle';
import '@fortawesome/pro-light-svg-icons/faUpRightAndDownLeftFromCenter';
import '@fortawesome/pro-light-svg-icons/faDownLeftAndUpRightToCenter';
import '@fortawesome/pro-light-svg-icons/faFileSpreadsheet';
import '@fortawesome/pro-light-svg-icons/faPresentationScreen';
import '@fortawesome/pro-light-svg-icons/faFileInvoice';
import '@fortawesome/pro-light-svg-icons/faChalkboardTeacher';
import '@fortawesome/pro-light-svg-icons/faCircleDollar';
import '@fortawesome/pro-light-svg-icons/faPersonFairy';
import '@fortawesome/pro-light-svg-icons/faCubes';
import '@fortawesome/pro-light-svg-icons/faUserHeadset';
import '@fortawesome/pro-light-svg-icons/faPalette';
import '@fortawesome/pro-light-svg-icons/faChartMixed';
import '@fortawesome/pro-light-svg-icons/faBrainCircuit';
import '@fortawesome/pro-light-svg-icons/faImageLandscape';
import '@fortawesome/pro-light-svg-icons/faHexagonPlus';
import '@fortawesome/pro-light-svg-icons/faPrintMagnifyingGlass';
import '@fortawesome/pro-light-svg-icons/faShieldHalved';
import '@fortawesome/pro-light-svg-icons/faDiagramSubtask';
import '@fortawesome/pro-light-svg-icons/faHandshake';
import '@fortawesome/pro-light-svg-icons/faBullhorn';
import '@fortawesome/pro-light-svg-icons/faCogs';
import '@fortawesome/pro-light-svg-icons/faHeadset';
import '@fortawesome/pro-light-svg-icons/faMicroscope';
import '@fortawesome/pro-light-svg-icons/faScaleBalanced';
import '@fortawesome/pro-light-svg-icons/faTruck';
import '@fortawesome/pro-light-svg-icons/faBuildings';
import '@fortawesome/pro-light-svg-icons/faInputText';
import '@fortawesome/pro-light-svg-icons/faProjectDiagram';
import '@fortawesome/pro-light-svg-icons/faPaperclip';
import '@fortawesome/pro-light-svg-icons/faFileVideo';
import '@fortawesome/pro-light-svg-icons/faCircleChevronUp';
import '@fortawesome/pro-light-svg-icons/faCircleChevronDown';
import '@fortawesome/pro-light-svg-icons/faUnlockKeyhole';
import '@fortawesome/pro-light-svg-icons/faChartScatter3d';
import '@fortawesome/pro-light-svg-icons/faSidebar';
import '@fortawesome/pro-light-svg-icons/faGlobe';
import '@fortawesome/pro-light-svg-icons/faSquare';
import '@fortawesome/pro-light-svg-icons/faSquareRss';
import '@fortawesome/pro-light-svg-icons/faAsterisk';
import '@fortawesome/pro-light-svg-icons/faCircleUser';
import '@fortawesome/pro-light-svg-icons/faUpFromBracket';
import '@fortawesome/pro-light-svg-icons/faHouseLock';
import '@fortawesome/pro-light-svg-icons/faXmarkToSlot';
import '@fortawesome/pro-light-svg-icons/faRobot';
import '@fortawesome/pro-light-svg-icons/faMagicWandSparkles';
import '@fortawesome/pro-light-svg-icons/faCircleExclamation';
import '@fortawesome/pro-light-svg-icons/faBook';
import '@fortawesome/pro-light-svg-icons/faImagePolaroid';
import '@fortawesome/pro-light-svg-icons/faVideo';
import '@fortawesome/pro-light-svg-icons/faCube';
import '@fortawesome/pro-light-svg-icons/faToolbox';
import '@fortawesome/pro-light-svg-icons/faTimer';
import '@fortawesome/pro-light-svg-icons/faThoughtBubble';
import '@fortawesome/pro-light-svg-icons/faSwap';
import '@fortawesome/pro-light-svg-icons/faFloppyDisk';
import '@fortawesome/pro-light-svg-icons/faWandMagicSparkles';
import '@fortawesome/pro-light-svg-icons/faXmark';
import '@fortawesome/pro-light-svg-icons/faFileVector';
import '@fortawesome/pro-light-svg-icons/faWrench';
import '@fortawesome/pro-light-svg-icons/faVectorPolygon';
import '@fortawesome/pro-light-svg-icons/faClose';
import '@fortawesome/pro-light-svg-icons/faCircleXmark';
import '@fortawesome/pro-light-svg-icons/faCloud';
import '@fortawesome/pro-light-svg-icons/faPlanetMoon';
import '@fortawesome/pro-light-svg-icons/faListCheck';
import '@fortawesome/pro-light-svg-icons/faUnlock';
import '@fortawesome/pro-light-svg-icons/faCheck';
import '@fortawesome/pro-light-svg-icons/faCirclePlus';
import '@fortawesome/pro-light-svg-icons/faCircleMinus';
import '@fortawesome/pro-light-svg-icons/faWandSparkles';
import '@fortawesome/pro-light-svg-icons/faHardDrive';
import '@fortawesome/pro-light-svg-icons/faLightbulb';
import 'url';
import 'highlight.js';
import '@mermaid-js/mermaid-zenuml/dist/mermaid-zenuml.core.mjs';
import 'lodash-es';
import 'react-native-markdown-display';
import '../../dist/index-ec953df8.esm.js';
import '../../dist/AppButton-a3bdb006.esm.js';
import 'expo-linear-gradient';
import '../../dist/index-9c3f5cad.esm.js';

const CardFooter = _ref => {
  let {
    footerHeading,
    subFooterHeading,
    footerHeadingStyle,
    subFooterHeadingStyle,
    leftIconDisplayed,
    rightIconDisplayed,
    leftIconOnPress,
    leftIconName,
    leftIconStyle,
    rightIconStyle,
    rightIconOnPress,
    rightIconName,
    containerStyle,
    rightIconSize = 30,
    leftIconSize = 30,
    ...props
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const _styles = styleGenerator$2(currentTheme);
  return /*#__PURE__*/React__default.createElement(View, {
    style: [_styles.container, containerStyle]
  }, /*#__PURE__*/React__default.createElement(View, null, /*#__PURE__*/React__default.createElement(AppText, {
    numberOfLines: 2,
    ellipsizeMode: "tail",
    style: [_styles.footerTitleStyle, footerHeadingStyle]
  }, footerHeading), /*#__PURE__*/React__default.createElement(AppText, {
    numberOfLines: 2,
    ellipsizeMode: "tail",
    style: [_styles.subfooterTitleStyle, subFooterHeadingStyle]
  }, subFooterHeading)));
};
const styleGenerator$2 = props => {
  var _props$theme, _props$theme2;
  return StyleSheet.create({
    image: {
      width: "auto",
      flex: 1
    },
    baseLeftIconStyle: {
      position: "relative",
      left: -10,
      top: 3
    },
    baseRightIconStyle: {
      position: "relative",
      right: -10,
      top: 3
    },
    container: {
      flexDirection: "row"
    },
    footerTitleStyle: {
      fontWeight: "bold",
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.medium_font_size
    },
    subfooterTitleStyle: {
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.small_font_size
    }
  });
};
CardFooter.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CardFooter",
  "props": {
    "rightIconSize": {
      "defaultValue": {
        "value": "30",
        "computed": false
      },
      "required": false
    },
    "leftIconSize": {
      "defaultValue": {
        "value": "30",
        "computed": false
      },
      "required": false
    }
  }
};

const AppOptions = _ref => {
  let {
    onMenuOptionClicked,
    menuOptions
  } = _ref;
  return /*#__PURE__*/React__default.createElement(View, null, menuOptions === null || menuOptions === void 0 ? void 0 : menuOptions.map(opt => /*#__PURE__*/React__default.createElement(AppText, {
    key: opt === null || opt === void 0 ? void 0 : opt.id,
    onPress: () => {
      onMenuOptionClicked && onMenuOptionClicked(opt);
    },
    isClickable: true
  }, opt === null || opt === void 0 ? void 0 : opt.label)));
};
AppOptions.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppOptions"
};

const CardHeader = _ref => {
  var _currentTheme$theme;
  let {
    heading,
    subHeading,
    headingStyle,
    subHeadingStyle,
    leftIconDisplayed,
    rightIconDisplayed,
    leftIconOnPress,
    leftIconName,
    leftIconStyle,
    rightIconStyle,
    rightIconOnPress,
    rightIconName,
    containerStyle,
    rightIconSize = 20,
    leftIconSize = 20,
    isRightIconClickable,
    isMenuAvailable,
    menuOptions,
    onMenuOptionClicked,
    shouldMenuCloseOnPress,
    headingColor,
    subHeadingColor,
    isRightIconPopupDisplayed,
    rightIconPopupContent,
    leftIconColor,
    subHeadingIcon,
    subHeadingIconSize,
    subHeadingIconColor,
    rightIconWrapperStyle,
    ...props
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const _styles = styleGenerator$1(currentTheme);
  const [isMenuModalOpen, setMenuModalOpen] = useState(false);
  return /*#__PURE__*/React__default.createElement(View, {
    style: [_styles.container, containerStyle]
  }, leftIconDisplayed && /*#__PURE__*/React__default.createElement(AppIcon, {
    size: leftIconSize,
    style: [_styles.baseLeftIconStyle, leftIconStyle],
    onPress: leftIconOnPress,
    icon: leftIconName,
    isClickable: leftIconOnPress,
    color: leftIconColor
  }), /*#__PURE__*/React__default.createElement(View, null, /*#__PURE__*/React__default.createElement(AppText, {
    color: headingColor,
    numberOfLines: 2,
    ellipsizeMode: "tail",
    style: [_styles.titleStyle, headingStyle]
  }, heading), /*#__PURE__*/React__default.createElement(AppText, {
    color: subHeadingColor,
    numberOfLines: 2,
    ellipsizeMode: "tail",
    style: [_styles.subtitleStyle, subHeadingStyle],
    leftIcon: subHeadingIcon,
    iconSize: subHeadingIconSize,
    leftIconColor: subHeadingIconColor
  }, subHeading)), rightIconDisplayed && isMenuAvailable && /*#__PURE__*/React__default.createElement(AppPopup, {
    icon: rightIconName,
    iconSize: rightIconSize,
    style: [_styles.baseRightIconStyle, rightIconStyle]
  }, /*#__PURE__*/React__default.createElement(AppOptions, {
    menuOptions: menuOptions,
    onMenuOptionClicked: opt => {
      setMenuModalOpen(!shouldMenuCloseOnPress);
    }
  })), rightIconDisplayed && !isMenuAvailable && /*#__PURE__*/React__default.createElement(Popable, {
    numberOfLines: 10,
    backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.tooltipBackgroundColor,
    style: [{
      top: 30,
      zIndex: 20,
      maxWidth: 200,
      width: 200
    }],
    content: rightIconPopupContent,
    action: "hover",
    position: "left"
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    isClickable: isRightIconClickable,
    icon: rightIconName,
    size: rightIconSize,
    style: [_styles.baseRightIconStyle, rightIconStyle],
    wrapperStyle: rightIconWrapperStyle,
    onPress: rightIconOnPress
  })));
};
const styleGenerator$1 = props => {
  var _props$theme;
  return StyleSheet.create({
    image: {
      width: "auto",
      flex: 1
    },
    baseLeftIconStyle: {
      position: "relative"
    },
    baseRightIconStyle: {
      position: "relative"
    },
    container: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between"
    },
    titleStyle: {
      fontWeight: "bold",
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.medium_font_size,
      justifyContent: "space-between"
    },
    subtitleStyle: {}
  });
};
CardHeader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CardHeader",
  "props": {
    "rightIconSize": {
      "defaultValue": {
        "value": "20",
        "computed": false
      },
      "required": false
    },
    "leftIconSize": {
      "defaultValue": {
        "value": "20",
        "computed": false
      },
      "required": false
    }
  }
};

const AppCard = _ref => {
  let {
    contentID,
    cardWidth = "fit-content",
    cardHeight = "fit-content",
    imageUrl,
    heading = "Card title",
    subHeading = "",
    contentTitle,
    contentDesc,
    leftButtonLabel = "Card secondary btn",
    rightButtonLabel = "Card primary btn",
    cardContentDisplayed,
    cardCoverDisplayed,
    cardActionsDisplayed,
    leftIconDisplayed,
    rightIconDisplayed,
    leftIconOnPress,
    leftIconName,
    leftIconStyle,
    rightIconStyle,
    rightIconOnPress,
    rightIconName,
    isRightIconClickable,
    CardHeaderDefault = CardHeader,
    CardFooterDefault = CardFooter,
    onCardPress,
    onPressLeftButton,
    onPressRightButton,
    elevation = 2,
    iconName,
    iconPosition,
    customContent,
    useUser,
    headerContainerStyle,
    footerHeadingStyle,
    subFooterHeadingStyle,
    footerHeading,
    subFooterHeading,
    style,
    children,
    isMenuAvailable = false,
    isHoverable = false,
    menuOptions = [],
    onMenuOptionClicked,
    shouldMenuCloseOnPress,
    disabled = false,
    headingStyle,
    subHeadingColor,
    headingColor,
    shadowColor,
    childrenViewStyle,
    isRightIconPopupDisplayed,
    rightIconPopupContent,
    leftIconColor,
    subHeadingStyle,
    subHeadingIcon,
    subHeadingIconSize,
    subHeadingIconColor,
    rightIconSize,
    rightIconWrapperStyle,
    ...props
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const _style = styleGenerator(currentTheme, cardWidth, cardHeight, shadowColor, disabled);
  const CardContent = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (heading || subHeading) && /*#__PURE__*/React__default.createElement(CardHeaderDefault, {
    heading: heading,
    rightIconDisplayed: rightIconDisplayed,
    leftIconDisplayed: leftIconDisplayed,
    leftIconOnPress: leftIconOnPress,
    leftIconName: leftIconName,
    leftIconStyle: leftIconStyle,
    rightIconStyle: rightIconStyle,
    rightIconOnPress: rightIconOnPress,
    rightIconName: rightIconName,
    isRightIconClickable: isRightIconClickable,
    subHeading: subHeading,
    headingStyle: headingStyle,
    headingColor: headingColor,
    containerStyle: headerContainerStyle,
    menuOptions: menuOptions,
    isMenuAvailable: isMenuAvailable,
    onMenuOptionClicked: onMenuOptionClicked,
    shouldMenuCloseOnPress: shouldMenuCloseOnPress,
    isRightIconPopupDisplayed: isRightIconPopupDisplayed,
    rightIconPopupContent: rightIconPopupContent,
    leftIconColor: leftIconColor,
    subHeadingStyle: subHeadingStyle,
    subHeadingIcon: subHeadingIcon,
    subHeadingIconSize: subHeadingIconSize,
    subHeadingIconColor: subHeadingIconColor,
    subHeadingColor: subHeadingColor,
    rightIconSize: rightIconSize,
    rightIconWrapperStyle: rightIconWrapperStyle
  }), /*#__PURE__*/React__default.createElement(View, {
    style: [{
      flex: 1
    }, childrenViewStyle]
  }, children), (footerHeading || subFooterHeading) && /*#__PURE__*/React__default.createElement(CardFooterDefault, {
    footerHeading: footerHeading,
    rightIconDisplayed: rightIconDisplayed,
    leftIconDisplayed: leftIconDisplayed,
    leftIconOnPress: leftIconOnPress,
    leftIconName: leftIconName,
    leftIconStyle: leftIconStyle,
    rightIconStyle: rightIconStyle,
    rightIconOnPress: rightIconOnPress,
    rightIconName: rightIconName,
    subFooterHeading: subFooterHeading,
    containerStyle: headerContainerStyle,
    footerHeadingStyle: footerHeadingStyle,
    subFooterHeadingStyle: subFooterHeadingStyle
  }));
  return /*#__PURE__*/React__default.createElement(TouchableOpacity, {
    onPress: () => {
      onCardPress && onCardPress();
      // Maybe it could be worth abstracting further this point
    },

    accessibilityLabel: props.accessibilityLabel,
    disabled: disabled
  }, isHoverable ? /*#__PURE__*/React__default.createElement(HoverableView, {
    style: [_style.container, {
      opacity: 0.9
    }, style],
    onHover: {
      opacity: 1
    }
  }, CardContent) : /*#__PURE__*/React__default.createElement(View, {
    style: [_style.container, style]
  }, CardContent));
};
const styleGenerator = (props, cardWidth, cardHeight, shadowColor, disabled) => {
  var _props$theme, _props$theme2, _props$theme3, _props$theme4, _props$theme5, _props$theme6;
  return StyleSheet.create({
    image: {
      width: "auto",
      flex: 1
    },
    caption_container: {
      padding: 5
    },
    titleStyle: {
      fontWeight: "bold",
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.largest_font_size,
      fontFamily: "normalFont"
    },
    subtitleStyle: {
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.medium_font_size,
      fontFamily: "normalFont"
    },
    container: {
      ...genericStyles.generateShadowStyleWithColor(shadowColor || (props === null || props === void 0 ? void 0 : (_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.shadowColor)),
      backgroundColor: disabled ? props === null || props === void 0 ? void 0 : (_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : _props$theme4.grey : props === null || props === void 0 ? void 0 : (_props$theme5 = props.theme) === null || _props$theme5 === void 0 ? void 0 : _props$theme5.cardBackground,
      borderColor: props === null || props === void 0 ? void 0 : (_props$theme6 = props.theme) === null || _props$theme6 === void 0 ? void 0 : _props$theme6.grey,
      borderWidth: 1,
      borderRadius: 10,
      marginTop: 20,
      marginBottom: 20,
      padding: 15,
      display: "flex",
      elevation: 5,
      width: cardWidth,
      height: cardHeight
    },
    contentContainer: {
      alignItems: "center",
      fontFamily: "normalFont"
    }
  });
};

// Specifies the default values for props:
AppCard.defaultProps = {
  heading: "Heading",
  subheading: "Subheading",
  image: "../../assets/chair.jpg"
};
AppCard.propsTypes = {
  main_image_source: PropTypes.object,
  heading: PropTypes.string,
  subheading: PropTypes.string
};
AppCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppCard",
  "props": {
    "cardWidth": {
      "defaultValue": {
        "value": "\"fit-content\"",
        "computed": false
      },
      "required": false
    },
    "cardHeight": {
      "defaultValue": {
        "value": "\"fit-content\"",
        "computed": false
      },
      "required": false
    },
    "heading": {
      "defaultValue": {
        "value": "\"Heading\"",
        "computed": false
      },
      "required": false
    },
    "subHeading": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "required": false
    },
    "leftButtonLabel": {
      "defaultValue": {
        "value": "\"Card secondary btn\"",
        "computed": false
      },
      "required": false
    },
    "rightButtonLabel": {
      "defaultValue": {
        "value": "\"Card primary btn\"",
        "computed": false
      },
      "required": false
    },
    "CardHeaderDefault": {
      "defaultValue": {
        "value": "CardHeader",
        "computed": true
      },
      "required": false
    },
    "CardFooterDefault": {
      "defaultValue": {
        "value": "CardFooter",
        "computed": true
      },
      "required": false
    },
    "elevation": {
      "defaultValue": {
        "value": "2",
        "computed": false
      },
      "required": false
    },
    "isMenuAvailable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "isHoverable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "menuOptions": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "subheading": {
      "defaultValue": {
        "value": "\"Subheading\"",
        "computed": false
      },
      "required": false
    },
    "image": {
      "defaultValue": {
        "value": "\"../../assets/chair.jpg\"",
        "computed": false
      },
      "required": false
    }
  }
};

export { AppCard as default };
